import React, { Component } from 'react'
import { PricingWrapper } from '~/styles'

class Pricing extends Component {
  render () {
    return <PricingWrapper >
      <div>
        <img className="pricing" src="/pricing.png" alt="" />
      </div>
    </PricingWrapper>
  }
}

export default Pricing



// WEBPACK FOOTER //
// ./src/App/Pricing/Pricing.js